import { START_DRAG_WINDOW,
        END_DRAG_WINDOW,
        SET_WINDOW_POSITION } from './actionTypes'

export function startDragWindow(isDraggingStateLoc) {
    return {
        type : START_DRAG_WINDOW,
        payload : {
            isDraggingStateLoc
        }
    }
}

export function setWindowPosition(position, positionStateLoc) {
    return {
        type : SET_WINDOW_POSITION,
        payload : {
            position,
            positionStateLoc
        }
    }
}

export function endDragWindow(isDraggingStateLoc, positionLoc, position) {
    return {
        type : END_DRAG_WINDOW,
        payload : {
            isDraggingStateLoc,
            positionLoc,
            position
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-drag/src/actions/actions.js